import script from "./ContactForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactForm.vue?vue&type=script&setup=true&lang=ts"

import "./ContactForm.vue?vue&type=style&index=0&id=bba16206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bba16206"]])

export default __exports__